import { Col, Form, Row } from "antd";
import { ClientSelector } from "../../common/components/clientSelector/clientSelector";
import { RecruiterSelector } from "../../common/components/recruiterSelector/recruiterSelector";
import styles from "./dashboard.module.scss";

export const DashboardHeader = ({
  client,
  recruiter,
  isTeamView,
  fetchRecruiters,
  onClientChange,
  onRecruiterChange,
  selectorsRef,
}) => {
  const clientId = client?.value;

  const headerSelectors = (
    <Row>
      <Col
        style={{
          width: isTeamView ? 472 : 230,
          flex: `0 0 ${isTeamView ? 472 : 230}px`,
        }}
      >
        <Form
          layout="inline"
          className={styles.recruiterDashboardHeaderSelectors}
        >
          <Form.Item
            style={{ width: isTeamView ? 228 : 230, flex: "0 0 auto" }}
          >
            <ClientSelector
              value={client}
              onChange={onClientChange}
              className={styles.recruiterDashboardHeaderSelect}
              style={{ width: "100%" }}
            />
          </Form.Item>
          {isTeamView && (
            <Form.Item style={{ width: 228, flex: "0 0 auto" }}>
              <RecruiterSelector
                fetchRecruiters={fetchRecruiters}
                clientId={clientId}
                value={recruiter}
                onChange={onRecruiterChange}
                disabled={!clientId}
                className={styles.recruiterDashboardHeaderSelect}
                style={{ width: "100%" }}
              />
            </Form.Item>
          )}
        </Form>
      </Col>
    </Row>
  );

  return (
    <span ref={selectorsRef} style={{ display: "inline-block" }}>
      {headerSelectors}
    </span>
  );
};
